module.exports = __webpack_public_path__ + "img/ren1.6fad3767.png";